
import { Button } from "@/components/ui/button";

interface NavigationProps {
  scrollToSection: (id: string) => void;
}

export const Navigation = ({ scrollToSection }: NavigationProps) => {
  return (
    <div className="absolute top-0 w-full z-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-center py-4">
          <div className="flex flex-wrap justify-center space-x-6">
            <button 
              onClick={() => scrollToSection('about')}
              className="text-gray-800 hover:text-primary transition-colors font-semibold"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('features')}
              className="text-gray-800 hover:text-primary transition-colors font-semibold"
            >
              Features
            </button>
            <button 
              onClick={() => scrollToSection('pricing')}
              className="text-gray-800 hover:text-primary transition-colors font-semibold"
            >
              Pricing
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className="text-gray-800 hover:text-primary transition-colors font-semibold"
            >
              FAQ
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
